import module from 'app/module.js'
import template from './template.html'

class AppExcelImportarTablaComponent {
  constructor ($filter) {
    this.filterBy = $filter('filter')
    this.data = null
    this.headers = null
    this.onChange = null
    this.ayuda = false
    this.encabezados = []
    this.resultados = []
    this.filas = []
    this.filtro = ''
  }

  $onChanges (changes) {
    if (changes.data) {
      this.encabezados = [...this.data.headers]
      this.filas = [...this.data.rows]
      this.filtrar()
    }
  }

  actualizar () {
    let data = this.filas.length ? {headers: this.encabezados, rows: this.filas} : null
    this.onChange({$event: {data}})
  }

  agregarColumna () {
    this.encabezados.push(undefined)

    this.actualizar()
  }

  agregarFila () {
    this.filas.unshift(new Array(this.encabezados.length))

    this.actualizar()
  }

  borrar () {
    this.filas.length = 0

    this.actualizar()
  }

  eliminarFila (fila) {
    this.filas.splice(this.filas.indexOf(fila), 1)

    this.actualizar()
  }

  filtrar () {
    this.resultados = this.filterBy(this.filas, this.filtro)
  }

  editar (row, index) {
    let value = prompt('Especifique el nuevo valor:', row[index])

    if (value !== null) {
      row[index] = value
      this.actualizar()
    }

    return this
  }
}

module.component('appExcelImportarTabla', {
  controller: AppExcelImportarTablaComponent,
  template,
  bindings: {
    data: '<',
    headers: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/app/components/excel/importar/tabla/component.js